<script setup lang="ts">
import { BCard } from 'bootstrap-vue-next';

import PendingSubmissions from '~/common/components/PendingSubmissions.vue';
</script>

<template>
  <BCard
    title="Event and content submissions"
    class="mb-3"
  >
    <p class="text-body-secondary">
      Review event and content submissions from contributors.
    </p>
    <PendingSubmissions
      show-empty-state
    />
  </BCard>
</template>
